const isDateExpired = (expirationDate: string) => {
  return (Date.parse(expirationDate) || 0) < Date.now();
};

export default isDateExpired;
